import { FormattedMessage, useIntl } from 'react-intl'

import { Link } from '@gto/ui/link'
import { Typography } from '@gto/ui/typography'

export const FreeBankrollRulesSection = () => {
  const { messages } = useIntl()

  const raw = messages['freeBankroll.rules.description'] as unknown
  const rules = Array.isArray(raw) ? (raw as string[]) : []

  if (!rules.length) {
    return null
  }

  return (
    <section className="flex flex-col pb-[104px] pt-[52px] md:pb-[40px] md:pt-[40px]">
      <Typography
        className="text-center font-semibold"
        component="h2"
        variant="h4"
      >
        <FormattedMessage id="freeBankroll.rules.title" />
      </Typography>

      <ul className="mt-8 list-outside list-disc text-text-primary marker:text-white/50">
        {rules.map((rule, index) => (
          <li
            // eslint-disable-next-line @eslint-react/no-array-index-key -- static i18n rules list, render-once, never reorders
            key={index}
            className="mb-2.5 ml-5"
          >
            <Typography
              className="uppercase tracking-[0.02em]"
              color="text.primary"
              variant="body3"
            >
              {renderRuleWithLink(rule)}
            </Typography>
          </li>
        ))}
      </ul>
    </section>
  )
}

const renderRuleWithLink = (rule: string) => {
  const websiteUrl = 'https://rbwizard.com'

  if (!rule.includes(websiteUrl)) {
    return rule
  }

  const [beforeLink, afterLink] = rule.split(websiteUrl)

  return (
    <>
      {beforeLink}
      <Link
        external
        className="text-[12px] tracking-[0.02em]"
        href={websiteUrl}
        underline="always"
      >
        {websiteUrl}
      </Link>
      {afterLink}
    </>
  )
}
